import React from "react";
import Navigation from "@/components/landing/Navigation";
import Hero from "@/components/landing/Hero";
import AboutUs from "@/components/landing/AboutUs";
import Advisors from "@/components/landing/Advisors";
import JoinTeam from "@/components/landing/JoinTeam";
import LifeCycle from "@/components/landing/LifeCycle";
import Pillars from "@/components/landing/Pillars";
import Methodology from "@/components/landing/Methodology";
import ClientProfile from "@/components/landing/ClientProfile";
import InvestmentPhilosophy from "@/components/landing/InvestmentPhilosophy";
import FinancialPartners from "@/components/landing/FinancialPartners";
import IndexedFunds from "@/components/landing/IndexedFunds";
import DCAStrategy from "@/components/landing/DCAStrategy";
import Insurers from "@/components/landing/Insurers";
import TrustGrid from "@/components/landing/TrustGrid";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import SideMenu from "@/components/landing/MobileSideMenu";

const Landing = () => {
  return (
    <main
      data-testid="landing-page"
      className="min-h-screen bg-[#0B0410] text-[#F9F6F0] font-sans-emb"
    >
      <Navigation />
      <Hero />
      <AboutUs />
      <ClientProfile />
      <Advisors />
      <JoinTeam />
      <LifeCycle />
      <Pillars />
      <Methodology />
      <InvestmentPhilosophy />
      <FinancialPartners />
      <IndexedFunds />
      <DCAStrategy />
      <Insurers />
      <TrustGrid />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
      <SideMenu />
    </main>
  );
};

export default Landing;
